import { memo, useState } from 'react';
import { useDebounce } from 'use-debounce';

import { useShortIdContext } from '@air/provider-short-id';

import { type BaseStringSelectProps, StringSelect } from '~/components/StringSelect';
import { usePublicCountriesList } from '~/swr-hooks/filters/usePublicCountriesList';

type PublicCountriesSelectProps = {
  boardId: string | undefined;
} & BaseStringSelectProps;

export const PublicCountriesSelect = memo(({ boardId, ...props }: PublicCountriesSelectProps) => {
  const { shortId } = useShortIdContext();
  const [searchValue, setSearchValue] = useState('');

  const [debouncedSearchValue] = useDebounce(searchValue, 200, {
    trailing: true,
  });

  const { data = [], isLoading } = usePublicCountriesList({
    search: debouncedSearchValue,
    shortId,
    boardId,
  });

  return (
    <StringSelect
      placeholder="Search for country"
      isLoading={isLoading}
      values={data}
      onInputChange={setSearchValue}
      {...props}
    />
  );
});

PublicCountriesSelect.displayName = 'PublicCountriesSelect';
